import { useEffect } from "react";
import { View, Div } from "@base-ui";
import { Footer, initializeCookieWarning } from "@domain-ui";
import { DialogAligner } from "../dialogAligner/DialogAligner";
import { useNotificationContext } from "@notifications/context";
import { ErrorBanner } from "@notifications/errorNotifications";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SingleColumnPage = function SingleColumnPage(_ref) {
  var children = _ref.children;
  var _useNotificationConte = useNotificationContext(),
    notification = _useNotificationConte.notification,
    showNotification = _useNotificationConte.showNotification;
  var height = showNotification && notification !== null && notification !== void 0 && notification.text ? "calc(100vh - 104px)" : "";
  useEffect(function () {
    initializeCookieWarning();
  }, []);
  return /*#__PURE__*/_jsxs(View, {
    id: "main-scroll-el",
    scrollY: true,
    maxHeight: true,
    height: height,
    children: [/*#__PURE__*/_jsx(ErrorBanner, {}), /*#__PURE__*/_jsx(Div, {
      as: "main",
      mb: "20px",
      minHeight: "100vh",
      children: children
    }), /*#__PURE__*/_jsx(Footer, {}), /*#__PURE__*/_jsx(DialogAligner, {})]
  });
};